import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CollectionAttributes } from 'src/app/models/advisor.interface';

@Component({
  selector: 'app-filter-modal',
  templateUrl: './filter-modal.component.html',
  styleUrls: ['./filter-modal.component.scss']
})
export class FilterModalComponent {
  filterOptions: CollectionAttributes;
  selectedFilters: CollectionAttributes;
  filterTypes: string[];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      options: CollectionAttributes;
      currentFilters: CollectionAttributes;
    },
    private dialogRef: MatDialogRef<FilterModalComponent>
  ) {
    this.filterOptions = data.options;
    this.selectedFilters = { ...data.currentFilters };
    this.filterTypes = Object.keys(this.filterOptions);
  }
  onCancel(): void {
    this.dialogRef.close();
  }
  onApply(): void {
    this.dialogRef.close(this.selectedFilters);
  }
  onClearAll(): void {
    this.selectedFilters = {
      state: [],
      year: []
    };
  }

  removeFilter(type: string, item: string): void {
    const idx = this.selectedFilters[type].indexOf(item);
    if (idx >= 0) {
      // Create a new array to trigger change detection
      this.selectedFilters[type] = [
        ...this.selectedFilters[type].slice(0, idx),
        ...this.selectedFilters[type].slice(idx + 1)
      ];
    }
  }
}
